import { ViewerCategory } from '@distribute/shared/api-types/viewers';
import { RootState } from '../../../app';

export const selectViewers = ({ viewers }: RootState) => viewers;

export const selectIsLeadCategory = ({ viewers }: RootState) =>
  viewers.category === ViewerCategory.LEAD;
